'use client';

import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import GlobalStyles from '@mui/material/GlobalStyles';

import { useSettings } from '@/hooks/use-settings';

import { layoutConfig } from '../config';
import { MainNav } from './main-nav';
import { SideNav } from './side-nav';
import DataContext from '@/contexts/DataContext';
import { logger } from '@/lib/default-logger';

export function VerticalLayout({ children }) {
  const { settings } = useSettings();
  const { menuConfig } = useContext(DataContext);
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);

  const handleMobileNavToggle = React.useCallback(() => {
    // logger.debug('[VerticalLayout] Toggling mobile nav:', !mobileNavOpen);
    setMobileNavOpen((prev) => !prev);
  }, []);

  return (
    <React.Fragment>
      <GlobalStyles
        styles={{
          body: {
            '--MainNav-height': '56px',
            '--MainNav-zIndex': 1000,
            '--SideNav-width': '280px',
            '--SideNav-zIndex': 1100,
            '--MobileNav-width': '320px',
            '--MobileNav-zIndex': 1100,
          },
        }}
      />
      <Box
        sx={{
          bgcolor: 'var(--mui-palette-background-default)',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          minHeight: '100%',
        }}
      >
        <SideNav 
          color={settings.navColor} 
          items={menuConfig}
          onMobileClose={() => setMobileNavOpen(false)}
          open={mobileNavOpen} 
        />
        <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column', pl: { lg: 'var(--SideNav-width)' } }}>
          <MainNav 
            items={menuConfig} 
            onMobileNavOpen={handleMobileNavToggle}
            isMobileNavOpen={mobileNavOpen}
          />
          <Box
            component="main"
            sx={{
              '--Content-margin': '0 auto',
              '--Content-maxWidth': 'var(--maxWidth-xl)',
              '--Content-paddingX': '24px',
              '--Content-paddingY': { xs: '24px', lg: '64px' },
              '--Content-padding': 'var(--Content-paddingY) var(--Content-paddingX)',
              '--Content-width': '100%',
              display: 'flex',
              flex: '1 1 auto',
              flexDirection: 'column',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}